import { useNavigate } from 'react-router-dom'
import BackButton from '../primitives/BackButton'
import styles from './SimplePageLayout.module.css'

interface SimplePageLayoutProps {
  title: string
  description?: string
  backTo?: string | -1
  children: React.ReactNode
}

export default function SimplePageLayout({
  title,
  description,
  backTo,
  children,
}: SimplePageLayoutProps) {
  const navigate = useNavigate()

  return (
    <div className={styles.shell}>
      {backTo !== undefined && (
        <div className={styles.back}>
          <BackButton onClick={() => (backTo === -1 ? navigate(-1) : navigate(backTo))} />
        </div>
      )}
      <h1 className={styles.title}>{title}</h1>
      {description && <p className={styles.description}>{description}</p>}
      <div className={styles.body}>{children}</div>
    </div>
  )
}
